import { render, staticRenderFns } from "./dictionaryRecord.vue?vue&type=template&id=71c2a9e6&scoped=true&"
import script from "./dictionaryRecord.vue?vue&type=script&lang=js&"
export * from "./dictionaryRecord.vue?vue&type=script&lang=js&"
import style0 from "./dictionaryRecord.vue?vue&type=style&index=0&id=71c2a9e6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71c2a9e6",
  null
  
)

export default component.exports